import axiosApiInstance from '../../interceptors/axiosApiInstance';
import {BASE_URL, NETWORK_ERROR} from '../config';
import {setServiceMessage} from '../../helpers/helper';

const MateService = {
    getAllMates: async function () {
        try {
            const response = await axiosApiInstance.get(BASE_URL + '/mates');
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deleteMates: async function (data) {
        try {
            const response = await axiosApiInstance.delete(BASE_URL + '/mates', {
                data: {id: data}
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.date : undefined;
        }
    },
    getMateByID: async function (id) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/mates?id=${id}`);
            return response.data;
        } catch (error) {
            if (error.response) {
                return setServiceMessage(error.response.data, 'CONTENT.MYMATES.');
            } else {
                return NETWORK_ERROR;
            }
        }
    },
    postDefault: async function (id) {
        try {
            const response = await axiosApiInstance.post(BASE_URL + '/mates/default', { id });
            return response.data;
        } catch (error) {
            if (error.response) {
                return setServiceMessage(error.response.data, 'CONTENT.MYMATES.');
            } else {
                return NETWORK_ERROR;
            }
        }
    }
}
export default MateService;